import { PageLink } from '../../../_start/layout/core';

export const redirectLinkManagementSubmenu: Array<PageLink> = [
  {
    title: 'Redirect Links',
    path: '/redirect-link-management/links',
    isActive: true,
  },
];
